import React, {
  useLayoutEffect,
  useState,
  useCallback,
  useEffect,
} from "react";
import {
  List,
  ExportButton,
  RefreshButton,
  TopToolbar,
  Datagrid,
  TextField,
  ReferenceInput,
  AutocompleteInput,
  ReferenceField,
  DateField,
  CreateButton,
  ShowButton,
  Filter,
  TextInput,
  BooleanField,
  SelectInput,
  GET_ONE,
  useRecordContext,
  useRedirect,
  useGetOne,
} from "react-admin";
import { Scrollbars } from "react-custom-scrollbars";
import Select from "react-select";
import myDataProvider from "../myRestProvider";
import {
  RUN_TIME_API_ENDPOINT,
  CommonHeaderOption,
  validateEmailId,
} from "../common/common";
import { unparse as convertToCSV } from "papaparse/papaparse.min";
import Modal from "react-responsive-modal";
import Swal from "sweetalert2";
import GetAppIcon from "@mui/icons-material/GetApp";
import ArrowBackIcon from "@mui/icons-material/ArrowBackIosNew";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import CreatableSelect from "react-select/creatable";

const apiUrl = RUN_TIME_API_ENDPOINT;

const ProjectShow = (props) => {
  // constructor(props) {
  //   super(props);
  //   this.state = {
  //     productList: [],
  //     clickitProductList: [],
  //     project: {},
  //     business: [],
  //     selectedClickitProduct: {},
  //   };
  // }
  const location = useLocation();
  const record = useRecordContext();
  const navigate = useNavigate();

  const businessID = localStorage.getItem("businessID");

  const {data: businessData} = useGetOne("businesses", { id: businessID});

  const [productList, setProductList] = useState([]);
  const [clickitProductList, setClickitProductList] = useState([]);
  const [project, setProject] = useState();
  const [business, setBusiness] = useState([]);
  const [selectedClickitProduct, setSelectedClickitProduct] = useState({});
  const [plantType, setPlantType] = useState('');
  const [showProducts, setShowProducts] = useState(true);
  const [rocksEnabledForProduct, setRocksEnabledForProduct] = useState(false);

  const AGGREGATE_PLANT_TYPE = "aggregate";
  const ASPHALT_PLANT_TYPE = "asphalt";
  const CEMENT_PLANT_TYPE = "cement";

  useEffect(() => {
    let _paramsUrl = location.pathname.split("/");
    let contractId;
    let projectId;
    let plantTypeExt;

    if (_paramsUrl.length > 1 && _paramsUrl[2] !== "") {
      let data = _paramsUrl[2].split("-");
      contractId = data[0];
      projectId = data[1];
      plantTypeExt = data[2];
    }

    const {project_title: projectTitle, project_number: projectNumber} = location?.state;

    setPlantType(plantTypeExt);
    // const url = `${apiUrl}/contract_products?filter=%7B%22project_id%22%3A%22${contractId}%22%7D&range=%5B0%2C24%5D&sort=%5B%22created_at%22%2C%22DESC%22%5D`;
    // const url = `${apiUrl}/contract_products?filter=%7B%22contract_id%22%3A%22${contractId}%22%2C%22business_id%22%3A%22${businessID}%22%2C%22project_id%22%3A%22${projectId}%22%7D&range=%5B0%2C24%5D&sort=%5B%22creation_date%22%2C%22DESC%22%5D`;
    const url = `${apiUrl}/contract_products/${contractId}?business_id=${businessID}&type=${plantTypeExt}&project_number=${projectNumber}&project_title=${projectTitle}`;
    fetch(url, CommonHeaderOption())
      .then((res) => {
        if (res.status === 401) {
          localStorage.removeItem("__state");
          location.pathname = "#/login";
        }
        return res.json();
      })
      .then((json) => {
        const abc2 = {};
        let isRocksEnabledForSome = false;
        // const abc = json.data.map((item, index) => ({
        //   [index]: { ...item.clickit_products[0] },
        // }));

        if(json?.items && Array.isArray(json?.items) && json?.items?.length > 0) {
          json.items.forEach((item, index) => {
            if(!isRocksEnabledForSome && item?.is_rocks_enabled) {
              isRocksEnabledForSome = true;
            }

            if (item?.clickit_products?.[0]?.product_name) {
              abc2[index] = {
                id: item?.clickit_products?.[0]?.id,
                value: item?.clickit_products?.[0]?.product_name,
                label: item?.clickit_products?.[0]?.product_name,
              };
            }
          });
        }
        
        setRocksEnabledForProduct(isRocksEnabledForSome);
        setProductList(json?.items || []);
        setProject({
          contract_number: json?.contract_number || '',
          project_title: json?.project_title || '',
          project_id: json?.project_id || '',
          contract_id: json?.contract_id || '',
          project_number: json?.project_number || '',
          customer: json?.customer || ''
        })
        if(json?.items && json?.items.length > 0) {
          getEmailData(json?.items || []);
        }
        setSelectedClickitProduct(abc2);
        // window.location.reload();
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Unable to process your request at this time. Please try again later.",
        });
        console.log("Error contracts_products", error);
      });
    fetchPeojectInfo(projectId);
    if(plantTypeExt !== ASPHALT_PLANT_TYPE) {
      fetchClickitProduct();
    }
  }, []); 

  useEffect(() => {
    shouldShowProducts()
  }, [plantType, rocksEnabledForProduct]);

  const shouldShowProducts = () => {
    if(plantType === ASPHALT_PLANT_TYPE) {
      return setShowProducts(false);
    }

    if((plantType === AGGREGATE_PLANT_TYPE) && rocksEnabledForProduct) {
      return setShowProducts(false)
    }

    if((plantType === CEMENT_PLANT_TYPE) && businessData?.cement_system?.toUpperCase() === 'ZONDA') {
      return setShowProducts(false)
    }

    setShowProducts(true)
  };

  const fetchPeojectInfo = (id) => {
    const url_ = `${apiUrl}/projects/${id}`;
    fetch(url_, CommonHeaderOption())
      .then((res) => {
        if (res.status === 401) {
          localStorage.removeItem("__state");
          location.pathname = "#/login";
        }
        return res.json();
      })
      .then((json) => {
        // setProject(json?.data);
        // setBusiness(json?.business);
        // Swal.fire({
        //   icon: "success",
        //   title: "",
        //   text: "Clickit Product refresh successfully",
        // });
        // window.location.reload();
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Unable to process your request at this time. Please try again later.",
        });
        console.log(error);
      });
  };

  const fetchClickitProduct = () => {
    const url_ = `${apiUrl}/clickit_products?filter=%7B%7D&range=%5B0%2C200%5D&sort=%5B%22id%22%2C%22ASC%22%5D`;
    fetch(url_, CommonHeaderOption())
      .then((res) => {
        if (res.status === 401) {
          localStorage.removeItem("__state");
          window.location.href = "#/login";
        }
        return res.json();
      })
      .then((json) => {
        // this.setState({
        //   clickitProductList: json.data.map((item) => ({
        //     id: item.id,
        //     value: item.product_name,
        //     label: item.product_name,
        //   })),
        // });
        const staticObject = {
          id: 1,
          value: "select",
          label: "Select None",
        };
        const dynamicArrayWithStatic = [
          staticObject,
          ...json.data.map((item) => ({
            id: item.id,
            value: item.product_name,
            label: item.product_name,
          })),
        ];

        setClickitProductList(dynamicArrayWithStatic);

        // setClickitProductList( json.data.map((item) => ({
        //   id: item.id,
        //   value: item.product_name,
        //   label: item.product_name,
        // })));
        Swal.fire({
          icon: "success",
          title: "",
          text: "Clickit Product refresh successfully",
        });
        // window.location.reload();
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Unable to process your request at this time. Please try again later.",
        });
        console.log(error);
      });
  };

  const clickirProductHandleChange = (e, index) => {
    // console.log("e====>", e);
    // console.log("index====>", index);
    // this.setState({
    //   selectedClickitProduct: {
    //     ...this.state.selectedClickitProduct,
    //     [index]: e,
    //   },
    // });
    setSelectedClickitProduct({ ...selectedClickitProduct, [index]: e });
  };
  const redirect = useRedirect();

  const addProductLink = () => {
    // const url = "/clickit_products/create";
    // window.open(url, "_blank");
    redirect("/clickit_products/create");
  };

  const onSaveHandler = (prod, item) => {
    const removeMapping = prod.value == "select" ? "true" : null;

    let _paramsUrl = location.pathname.split("/");
    let projectId;
    if (_paramsUrl.length > 1 && _paramsUrl[2] !== "") {
      let data = _paramsUrl[2].split("-");
      projectId = data[1];
    }
    const formData = {
      remove_mapping: removeMapping,
      clickit_product_id: prod.id,
      contract_product_id: item,
      project_id: project.project_id || projectId,
    };
    // console.log("formData ===>", formData);
    const url_ = `${apiUrl}/product_mapping`;
    const options = CommonHeaderOption();
    options.method = "POST";
    options.body = JSON.stringify({ formData });
    fetch(url_, options)
      .then((res) => {
        if (res.status === 401) {
          localStorage.removeItem("__state");
          window.location.href = "#/login";
        }
        return res.json();
      })
      .then((json) => {
        Swal.fire({
          icon: "success",
          title: "Great...",
          text:
            removeMapping == "true"
              ? "Product mapping is removed."
              : "Product mapping is done.",
        });
        // window.location.reload();
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Unable to process your request at this time. Please try again later.",
        });
        console.log(error);
      });
  };

  const handleclick = () => {
    // this.props.goback();
    console.log("GO BACK");
    props.history.goBack();
  };

  /////////////////////////////////////////////////////////////////

  const [showLoader, setShowLoader] = useState(false);
  const [successMsg, setSuccessMsg] = useState(false);
  const [saveButtonDisabled, setSaveButtonDisabled] = useState(true);
  const [errorMsg, setErrorMsg] = useState(false);
  const [errorMsgText, setErrorMsgText] = useState(null);
  const [saleOffNameSapCode, setSaleOffNameSapCode] = useState([]);
  const [saleOffList, setSaleOffList] = useState([]);
  const [originalList, setOriginalList] = useState([]);
  const [modalEmailShow, setEmailModalShow] = useState(false);
  const [validEmailError, setValidEmailError] = useState(false);

  const getEmailData = (data) => {
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = "GET";

    if (data.length > 0) {
      fetch(
        `${apiUrl}/get_order_email_area_mapping?contract_number=${data[0].contract_number}`,
        options
      )
        .then((res) => {
          return res.json();
        })
        .then((jsonD) => {
          if (Object.keys(jsonD).length > 0) {
            let obj = {};
            obj.order_notification_emails = jsonD.order_notification_emails;
            obj.loadingShow = false;
            setOriginalList(
              obj.order_notification_emails.map((item) => ({
                id: Date.now(),
                value: item,
                label: item,
              }))
            );
            setSaleOffList(
              obj.order_notification_emails.map((item) => ({
                id: Date.now(),
                value: item,
                label: item,
              }))
            );
            setSaleOffNameSapCode(
              obj.order_notification_emails.map((item) => ({
                id: Date.now(),
                value: item,
                label: item,
              }))
            );
          }
        });
    }
  };

  const handleChange = (e) => {
    let currentSelectedEmail = e.length ? e[e.length - 1] : "";
    if (currentSelectedEmail != "") {
      if (validateEmailId(currentSelectedEmail.value)) {
        setValidEmailError(false);
      } else {
        setValidEmailError(true);
      }
    }
    const arr = [...originalList];

    let result =
      arr &&
      arr.filter(
        (item) => e && e.filter((i) => i.value === item.value).length === 0
      );
    if (e === null) {
      result = [...originalList];
      setSaleOffList([]);
    }
    setSaleOffList(e);
    setSaleOffNameSapCode(result);
  };

  const formSave = (e) => {
    e.preventDefault();
    setShowLoader(true);
    setSaveButtonDisabled(false);
    // this.setState({
    //   showLoader: true,
    //   saveButtonDisabled: false

    // });
    // const checkType = type === 'Sales' || type === 'Region' || type === 'customerGroup' ?
    //   'Business' : type;
    const formData = {
      contract_number: productList.length > 0 && productList[0].contract_number,
      email_list: saleOffList,
    };
    const apiUrl = RUN_TIME_API_ENDPOINT;
    const options = CommonHeaderOption();
    options.method = "PATCH";
    options.body = JSON.stringify({
      contract_number: productList.length > 0 && productList[0].contract_number,
      email_list: saleOffList,
    });

    return fetch(`${apiUrl}/order_notification_emails`, options)
      .then((res) => {
        if (res) {
          return res.json();
        }
      })
      .then((res) => {
        if (res.errorMsg) {
          setErrorMsg(true);
          setShowLoader(false);
          setErrorMsgText(res.errorMsg);
          setEmailModalShow(false);
          setTimeout(() => {
            setErrorMsg(false);
            setSaveButtonDisabled(true);
          }, 3000);
        } else {
          setShowLoader(false);
          setSaveButtonDisabled(true);
          setSuccessMsg(true);
          setEmailModalShow(false);
          setTimeout(() => {
            setSuccessMsg(false);
          }, 2000);
          // setTimeout(() => {
          //   navigate(`/businesses`);
          // }, 3000)
          setSaveButtonDisabled(false);
        }
      })
      .catch((error) => {
        setEmailModalShow(false);
        console.log(error);
      });
  };

  const cancelClick = () => {
    setSaleOffList([]);
    setSaleOffNameSapCode(originalList);
  };

  const onCloseEmailModal = () => {
    setEmailModalShow(false);
  };

  //////////////////////////////////////////////////////////////////////
  console.log("projectData", project)
  return (
    <div className="project-contract">
      <div className="product-btn-grp">
        {/* <button onclick={handleclick}>go back</button> */}
        <div>
          <p className="product-detail">
            Project Number: {project?.project_number}
          </p>
        </div>
        <div>
          <p className="product-detail">
            Project Title: {project?.project_title}
          </p>
        </div>
        <div>
          <p className="product-detail">
            Contract Number: {project?.contract_number}
          </p>
        </div>
        <div>
          {/* <p className="product-detail">
            Customer(s):{" "}
            {business?.length > 0 &&
              business.map((b, index) => (
                <>
                  <a href={`/businesses/${b.id}/show`}>
                    {b.name}
                    {business?.length === index + 1 ? "" : " | "}
                  </a>
                </>
              ))}
          </p> */}
          <p className="product-detail">
            Customer(s): {project?.customer}
          </p>
        </div>
        {showProducts && (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <p className="product-detail">
              {
                // originalList?.length > 0 &&
                `Order notification email(s):`
              }
              {saleOffList?.length > 0 &&
                saleOffList?.map((b, index) => (
                  <>
                    {b.value}
                    {saleOffList?.length === index + 1 ? "" : ", "}
                  </>
                ))}
            </p>
            {
              // originalList?.length > 0 &&
              // <div>
              <button
                className="product-btn"
                onClick={() => setEmailModalShow(true)}
              >
                Edit
              </button>
              // </div>s
            }
          </div>
        )}

        {modalEmailShow && (
          <Modal open={modalEmailShow} onClose={onCloseEmailModal} center>
            {/*  */}

            {
              <div className="unassign-bulklist">
                <h5>Order notification emails</h5>

                <label className="select-label">
                  Order notification emails (add/edit, minimum 1 email required)
                  <sup className="asterisk">*</sup>
                </label>
                <div className="select-retailer" style={{ width: "700px" }}>
                  <CreatableSelect
                    value={saleOffList}
                    onChange={handleChange}
                    options={saleOffNameSapCode}
                    isMulti
                  />
                  <button onClick={cancelClick}>Clear</button>
                </div>
                {validEmailError && (
                  <div className="email-login-error">
                    {"Please enter valid email address"}
                  </div>
                )}
              </div>
            }

            {/* {saveButtonDisabled && */}
            {/* <div className="so-save-button">
                <button className={( saleOffList == null ||saleOffList?.length <=0 ) ? 'disable-save' : ''}
                  disabled={( saleOffList == null ||saleOffList?.length <=0 || validEmailError)}
                  onClick={(e) => formSave(e)}>Save</button>
              </div> */}
            {/* } */}

            {showLoader ? (
              <div className="save-loader" />
            ) : (
              <div className="so-save-button">
                <button
                  className={
                    saleOffList == null || saleOffList?.length <= 0
                      ? "disable-save"
                      : ""
                  }
                  disabled={
                    saleOffList == null ||
                    saleOffList?.length <= 0 ||
                    validEmailError
                  }
                  onClick={(e) => formSave(e)}
                >
                  Save
                </button>
              </div>
            )}
            {successMsg && (
              <div className="so-updated">Successfully Created </div>
            )}
            {errorMsg && <div className="so-email-exist">{errorMsgText}</div>}

            {/*  */}
          </Modal>
        )}
      </div>

      {showProducts && (
        <div className="product-btn-grp">
          <button className="product-btn" onClick={addProductLink}>
            Add ClickIt Product
          </button>
          <button className="product-btn" onClick={fetchClickitProduct}>
            Refresh ClickIt Product
          </button>
        </div>
      )}

      <button className="back-btn" onClick={() => navigate(-1)}>
        <ArrowBackIcon />
        Back
      </button>
      <div className="ct-table">
        <div className="ct-table-head-row">
          <div className="ct-table-head">Product name</div>
          <div className="ct-table-head">Product Number</div>
          <div className="ct-table-head-ln">Line No.</div>

          {/* <div className="ct-table-head">Contract Number</div> */}
          <div className="ct-table-head">Location</div>
          {showProducts && (
            <div className="ct-table-head-cp">ClickIt Product</div>
          )}
        </div>
        <div className="ct-table-scroll">
          {productList?.length > 0 &&
            productList.map((item, index) => (
              <div className="ct-table-data-row">
                <div className="ct-table-data">{item.product_description}</div>
                <div className="ct-table-data">{item.product_code}</div>
                <div className="ct-table-data-ln">{item.line_number}</div>
                {/* <div className="ct-table-data">{item.contract_number}</div> */}
                <div className="ct-table-data">{item.works_name}</div>
                {showProducts && (
                  <div className="ct-table-data-cp column-with-btn">
                    <Select
                      onChange={(e) => clickirProductHandleChange(e, index)}
                      isDisabled={!showProducts || !project?.project_id || !project?.contract_id}
                      value={selectedClickitProduct[index]}
                      options={
                        clickitProductList?.length > 0 ? clickitProductList : []
                      }
                    />
                    <button
                      className="ct-save-btn"
                      style={!showProducts || !project?.project_id || !project?.contract_id ? {backgroundColor: 'rgba(0,0,0,0.5)'} : {}}
                      disabled={!!!selectedClickitProduct[index] || !showProducts || !project?.project_id || !project?.contract_id}
                      onClick={() =>
                        onSaveHandler(selectedClickitProduct[index], item.id)
                      }
                    >
                      Save
                    </button>
                  </div>
               )} 
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default ProjectShow;
